import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const AddFilterIcon = forwardRef<SVGSVGElement, IconProps>(function AddFilterIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <g clipPath="url(#add_filter_clip0_2107_405003)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7489 8.03677C10.9165 8.03677 9.42576 9.49306 9.42576 11.2833C9.42576 11.8923 9.6011 12.4709 9.90512 12.9502L9.91093 12.9593C10.4845 13.8954 11.5402 14.5298 12.7489 14.5298C13.96 14.5298 15.0138 13.9019 15.5859 12.9613L15.5904 12.9538C15.8979 12.4622 16.0721 11.8901 16.0721 11.2833C16.0721 9.49306 14.5814 8.03677 12.7489 8.03677ZM7.99789 11.2833C7.99789 8.72267 10.1279 6.64184 12.7489 6.64184C15.37 6.64184 17.5 8.72267 17.5 11.2833C17.5 12.1529 17.2501 12.9744 16.8111 13.6776C15.9889 15.0265 14.477 15.9247 12.7489 15.9247C11.0189 15.9247 9.50948 15.0168 8.68851 13.6804C8.24642 12.9815 7.99789 12.1503 7.99789 11.2833Z"
          fill={color || 'currentColor'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6337 11.2664C10.6337 10.9362 10.9077 10.6686 11.2457 10.6686H14.2629C14.6008 10.6686 14.8748 10.9362 14.8748 11.2664C14.8748 11.5966 14.6008 11.8642 14.2629 11.8642H11.2457C10.9077 11.8642 10.6337 11.5966 10.6337 11.2664Z"
          fill={color || 'currentColor'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7516 9.23241C13.0896 9.23241 13.3635 9.50007 13.3635 9.83024V12.7778C13.3635 13.108 13.0896 13.3757 12.7516 13.3757C12.4136 13.3757 12.1397 13.108 12.1397 12.7778V9.83024C12.1397 9.50007 12.4136 9.23241 12.7516 9.23241Z"
          fill={color || 'currentColor'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.93077 1.39492C2.40405 1.39492 1.92787 1.81599 1.92787 2.45772V4.39236C1.92787 4.50585 1.97457 4.7174 2.09221 4.97249C2.20655 5.22043 2.35661 5.44122 2.49716 5.58128L2.5049 5.58899L5.76853 8.94354C5.78252 8.95791 5.79586 8.97286 5.80854 8.98834C6.02906 9.25763 6.234 9.61184 6.38503 9.97828C6.53444 10.3408 6.65342 10.7692 6.65342 11.1843V15.6264C6.65342 16.3851 7.54831 16.8645 8.21915 16.4645L9.41098 15.713C9.41926 15.7078 9.42765 15.7027 9.43615 15.6978C9.49752 15.6626 9.61094 15.5541 9.71341 15.3608C9.79239 15.2118 9.83662 15.065 9.85168 14.9525C9.37869 14.6043 8.98531 14.1686 8.68556 13.6788C8.24638 12.9755 7.9963 12.1538 7.9963 11.2839C7.9963 8.72332 10.1263 6.64249 12.7474 6.64249C12.9749 6.64249 13.2007 6.65815 13.4221 6.69016L14.6334 5.64801C14.7727 5.50398 14.9362 5.26815 15.0659 4.98981C15.2017 4.6982 15.2716 4.42169 15.2716 4.21797V2.37471C15.2716 1.83825 14.8178 1.39492 14.2687 1.39492H2.93077ZM0.5 2.45772C0.5 1.09009 1.57067 0 2.93077 0H14.2687C15.6064 0 16.6995 1.06787 16.6995 2.37471V4.21797C16.6995 4.68681 16.5526 5.16589 16.3655 5.5676C16.1772 5.97179 15.9192 6.35957 15.6369 6.64089C15.6247 6.65305 15.6121 6.66477 15.599 6.67603L14.1031 7.96301C13.9283 8.11339 13.6894 8.17102 13.4631 8.11742C13.2416 8.06497 13.0009 8.03742 12.7474 8.03742C10.9149 8.03742 9.42417 9.49371 9.42417 11.2839C9.42417 11.8907 9.59831 12.4629 9.90586 12.9545L9.90977 12.9608C10.1683 13.384 10.5214 13.7405 10.9446 13.9939C11.1564 14.1207 11.2855 14.3459 11.2855 14.5886V14.8709C11.2855 15.2609 11.1598 15.6655 10.9814 16.0022C10.8078 16.3297 10.5393 16.6771 10.1747 16.8917L8.97527 17.6479C7.41988 18.5875 5.22556 17.5561 5.22556 15.6264V11.1843C5.22556 11.0099 5.1703 10.7657 5.06049 10.4993C4.95737 10.2491 4.82602 10.0274 4.7105 9.88083L1.47339 6.55366C1.19084 6.27081 0.95568 5.90394 0.790364 5.54547C0.627526 5.19237 0.5 4.77706 0.5 4.39236V2.45772Z"
          fill={color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="add_filter_clip0_2107_405003">
          <rect width="18" height="18" fill="transparent" />
        </clipPath>
      </defs>
    </SvgStyled>
  );
});
